enum PartnerCommissionFormatEnum {
    Dollars = 'DOLLARS',
    Percentage = 'PERCENTAGE',
}

export default PartnerCommissionFormatEnum;
